<div class="scrollbar" #Scrollbar id="scrollbar" [ngClass]="{expanded: showImageNumber || isPageSmall}" (touchstart)="onMouseDownScrollbar($event)" (mousedown)="onMouseDownScrollbar($event)">
  <div class="scrollbar-handle" [ngStyle]="{height: height, top: top + 'px'}" (mousedown)="showImageNumber=true" (touchstart)="showImageNumber=true"
    (mouseup)="showImageNumber=false">
  </div>
  <div class="index-popup" *ngIf="showImageNumber" [ngStyle]="{top: (top-20) + 'px'}">
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
      {{imageNumber+1}}
    </div>
  </div>
</div>